import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Alert, Button, Skeleton } from './ui/Primitives';
import { ROUTES } from './navigation';
import { getBackendHost } from '../utils/backendHost';

export default function PhoneNumberSetupRedirect() {
  const navigate = useNavigate();
  const [error, setError] = useState(false);
  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    let active = true;
    const token = localStorage.getItem('jwt_authorization');
    if (!token) {
      navigate('/signin', { replace: true });
      return;
    }
    setError(false);
    async function redirect() {
      try {
        const response = await axios.post(`${getBackendHost()}/organization`, { jwt_token: token });
        if (!active) return;
        const organization = response.data.organization;
        if (!organization) throw new Error('Organization unavailable');
        navigate(organization.provisioned_number || organization.phone_number ? ROUTES.overview : '/onboarding', { replace: true });
      } catch (requestError) {
        if (!active) return;
        if (requestError.response?.status === 401) {
          navigate('/signin', { replace: true });
          return;
        }
        setError(true);
      }
    }
    redirect();
    return () => { active = false; };
  }, [navigate, attempt]);

  return <div className="page-content">
    {error ? <Alert tone="danger" actions={<Button onClick={() => setAttempt(value => value + 1)}>Try again</Button>}>
      We couldn’t check your phone number. Please try again.
    </Alert> : <Skeleton height={40} />}
  </div>;
}
